import { Action, action, State, ThunkOn, thunkOn } from 'easy-peasy';
import { PlayerError } from '../errors/PlayerError';
import { StoreState } from './store';

export interface ErrorState {
  error: PlayerError | null;
  setError: Action<ErrorState, PlayerError>;
  reset: Action<ErrorState>;
  onPlayerMount: ThunkOn<ErrorState, any, StoreState>;
  onPlayerDestroy: ThunkOn<ErrorState, any, StoreState>;
  onErrorOccurred: ThunkOn<ErrorState, any, StoreState>;
}

const initialState: State<ErrorState> = {
  error: null,
};

export const errorState: ErrorState = {
  /*================
   * State      
   ================*/
  ...initialState,

  /*================
   * Actions      
   ================*/

  setError: action((state, error) => {
    state.error = error;
  }),

  reset: action((state) => {
    Object.assign(state, { ...initialState });
  }),

  onPlayerMount: thunkOn(
    function observer(_, storeActions) {
      return [storeActions.config.load.startType];
    },
    function handler(actions) {
      actions.reset();
    }
  ),

  onPlayerDestroy: thunkOn(
    function observer(_, storeActions) {
      return [storeActions.player.destroy.startType];
    },
    function handler(actions) {
      actions.reset();
    }
  ),

  onErrorOccurred: thunkOn(
    function observer(actions) {
      return [actions.setError];
    },
    function handler(_, event, { getStoreState }) {
      const storeState = getStoreState();
      const error = event.payload;

      if (storeState.config.onErrorCallback) {
        storeState.config.onErrorCallback(error);
      }
    }
  ),
};
